module.exports = {
  couponOnlyFlowNasids: [10916,10911,9740,9746,9951,9749],
  page: null,
  panel: [0],
  view: "",
  createDataVoucher: false,
  cumulatedData: {},
  showDataSettingWarning: false,
  showPass: false,
  showPlans: false,
  customerPopup: {},
  userMobile: 0,
  otp: '',
  planId: 0,
  userData: 0,
  popup: {
    type: "info",
    visible: false,
    text: ""
  },
  bottomPopup: {
    type: "info",
    visible: false,
    text: ""
  },
  //sessionTimeOut: { value: null, text: null },
  sessionTimeOut: null,
  sessionValues: [
    "600",
    "900",
    "1200",
    "1800",
    "3600",
    "7200",
    "10800",
    "14400",
    "21600",
    "43200",
    "86400",
    "259200",
    "604800",
    "2419200"
  ],
  sessionLabels: [
    "10 Min",
    "15 Min",
    "20 Min",
    "30 Min",
    "1 hr",
    "2 hrs",
    "3 hrs",
    "4 hrs",
    "6 hrs",
    "12 hrs",
    "1 Day",
    "3 Days",
    "1 Week",
    "4 Wks"
  ],
  dataLimit: null,
  datalimitLabels: [
    "100 MB",
    "300 MB",
    "500 MB",
    "700 MB",
    "1 GB",
    "2 GB",
    "5 GB",
    "10 GB",
    "20 GB",
    "30 GB",
    "50 GB",
    "100 GB",
    "Unlimited"
  ],
  datalimitValues: [
    "102400",
    "307200",
    "512000",
    "716800",
    "1048576",
    "2097152",
    "5242880",
    "10485760",
    "20971520",
    "31457280",
    "52428800",
    "104857600",
    ""
  ],
  nasDataLimit: null,
  nasDatalimitLabels: [
    "100 MB",
    "300 MB",
    "500 MB",
    "700 MB",
    "1 GB",
    "2 GB",
    "5 GB",
    "10 GB",
    "20 GB",
    "30 GB",
    "50 GB",
    "100 GB",
    "Unlimited"
  ],
  nasDatalimitValues: [
    "100",
    "300",
    "500",
    "700",
    "1024",
    "2048",
    "5120",
    "10240",
    "20480",
    "30720",
    "51200",
    "102400",
    ""
  ],
  sessionItems: [
    { value: "600", text: "10 Minutes" },
    { value: "900", text: "15 Minutes" },
    { value: "1200", text: "20 Minutes" },
    { value: "1800", text: "Half an hour" },
    { value: "3600", text: "1 hour" },
    { value: "7200", text: "2 hours" },
    { value: "10800", text: "3 hours" },
    { value: "14400", text: "4 hours" },
    { value: "21600", text: "6 hours" },
    { value: "43200", text: "12 hours" },
    { value: "86400", text: "24 hours" },
    { value: "259200", text: "3 Days" },
    { value: "604800", text: "1 Week" },
    { value: "2419200", text: "4 Wks" }
  ],
  showAdvancedSettings: false,
  planNPayPage: null,
  planNPayOn: false,
  editUpi: false,
  showMaxDataDialog: false,
  showMaxDeviceDialog: false,
  showMaxTimeDialog: false,
  advancedConfiguration: {
    settingId: null,
    advanceConfigs: {
      AUTH_TYPE: {
        configType: 1,
        parameters: ["0"],
        value: null
      },
      ROUTER_SPLASH_IMAGE: {
        configType: 2,
        parameters: [""],
        value: null
      },
      LOGIN_PAGE_IMAGE: {
        configType: 3,
        parameters: [""],
        value: null
      },
      LANDING_PAGE_CONFIG: {
        configType: 4,
        parameters: [""],
        value: null
      },
      TEMPLATE_CONFIG: {
        configType: 5,
        parameters: [""],
        value: null
      },
      SHINE_PLUS_ACTIVATION: {
        configType: 6,
        parameters: [""],
        value: null
      },
      DEVICE_ACTIVATION: {
        configType: 7,
        parameters: [""],
        value: null
      },
      OPERATING_HOURS: {
        configType: 8,
        parameters: null,
        value: null
      },
      FACEBOOK_PAGE: {
        configType: 9,
        parameters: [""],
        value: null
      },
      FACEBOOK_CHECKIN: {
        configType: 11,
        parameters: [""],
        value: null
      },
      HIDE_QUESTION: {
        configType: 12,
        parameters: ["0"],
        value: null
      },
      NO_OF_DEVICES_PER_USER: {
        configType: 13,
        parameters: [""],
        value: null
      },
      GLOBAL_OTP: {
        configType: 14,
        parameters: null,
        value: null
      },
      AUTO_LOGIN_SPAN: {
        configType: 15,
        parameters: [""],
        value: null
      },
      VALIDATE_USER_LOGIN: {
        configType: 16,
        parameters: [""],
        value: null
      },
      DATA_VOUCHER_DETAILS: {
        configType: 17,
        parameters: [""],
        value: null
      },
      OVERRIDE_OTP: {
        configType: 18,
        parameters: [""],
        value: null
      },
      LANGUAGE_PREFERENCE: {
        configType: 19,
        parameters: [""],
        value: null
      },
      NAS_DAILY_DATA_LIMIT: {
        configType: 20,
        parameters: [""],
        value: null
      }
    }
  },
  advancedSettings: {
    settingId: null,
    vipNumber: [],
    whitelistNumber: [],
    blockNumber: [],
    vipMac: [],
    whitelistMac: [],
    blacklistMac: []
  },
  dataPlanSettings: [],
  reportData: {
    userDuration: "Today",
    dataDuration: "Today",
    totalUsers: 0,
    reportsTotalUsers: 0,
    totalDataUsed: 0,
    reportsTotalDataUsed: 0,
    downloadedData: 0,
    uploadedData: 0,
    connectionTime: 0,
    connectionStatus: null
  },
  doneRegisteredUser: [],
  pendingRegisterUser: [],
  couponUsers: [],
  basicSettings: {
    ssid: null,
    ssidPassword: null,
    settingId: null,
    ex7: "en",
    maxDataPerDay: 0,
    sessionTimeOut: "",
    connectionTime: "",
    connectionStatus: 0,
    totalDataUsed: 0,
    downloadedData: 0,
    uploadedData: 0,
    devicesPerUser: 0,
    autoLogin: false
  },
  tab: null,
  passwordConfirmed: false,
  showPasswordPopup: false
};
